import React, { useState } from "react";
import { Helmet } from "react-helmet";
import PageLayout from "../../components/navigation/PageLayout";
import Icon from "../../components/AppIcon";
import { useTenantContext } from "../../contexts/TenantContext";
import DistributionHistoryTab from "./components/DistributionHistoryTab";
import PayrollExportTab from "./components/PayrollExportTab";
import EmployeeStatementsTab from "./components/EmployeeStatementsTab";
import DistributionAnalyticsTab from "./components/DistributionAnalyticsTab";
import HmrcComplianceTab from "./components/HmrcComplianceTab";

const TABS = [
  { id: "history", label: "Distribution History", icon: "FileText" },
  { id: "payroll", label: "Payroll Export", icon: "FileSpreadsheet" },
  { id: "statements", label: "Employee Statements", icon: "Users" },
  { id: "analytics", label: "Analytics", icon: "PieChart" },
  { id: "compliance", label: "HMRC Compliance", icon: "Shield" },
];

const Reports = () => {
  const { selectedTenant, needsTenantSelection, isGlobalAdmin } = useTenantContext();
  const shouldFetchData = !isGlobalAdmin || selectedTenant;
  const [activeTab, setActiveTab] = useState("history");

  const breadcrumbs = [
    { label: "Dashboard", path: "/dashboard-overview" },
    { label: "Reports", path: "/reports" },
  ];

  // Select Tenant Empty State for Global Admins
  if (isGlobalAdmin && needsTenantSelection) {
    return (
      <>
        <Helmet><title>Reports - Rocket Tronc</title></Helmet>
        <PageLayout title="Reports" description="View and export TRONC reports." breadcrumbs={breadcrumbs}>
          <div className="card p-12 text-center">
   <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
           <Icon name="Building2" size={40} className="text-primary" />
        </div>
      <h2 className="text-2xl font-bold mb-3">Select a Tenant</h2>
            <p className="text-muted-foreground mb-6 max-w-md mx-auto">
      As a Global Administrator, please select a tenant from the sidebar to view reports.
            </p>
 </div>
        </PageLayout>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Reports - {selectedTenant?.name || "Rocket Tronc"}</title>
      </Helmet>
      <PageLayout
      title="Reports"
      description={
          selectedTenant
      ? `View and export TRONC reports for ${selectedTenant.name}`
        : "View and export TRONC distribution reports and analytics"
        }
 breadcrumbs={breadcrumbs}
      >
{/* Tab Navigation */}
      <div className="border-b border-border mb-6 -mt-2">
          <nav className="flex gap-1 overflow-x-auto pb-px" aria-label="Report tabs">
          {TABS.map((tab) => (
              <button
   key={tab.id}
                onClick={() => setActiveTab(tab.id)}
className={`flex items-center gap-2 px-4 py-3 text-sm font-semibold whitespace-nowrap border-b-2 transition-base ${
        activeTab === tab.id
? "border-primary text-primary"
     : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
           }`}
        >
       <Icon name={tab.icon} size={16} />
       {tab.label}
              </button>
          ))}
       </nav>
   </div>

  {/* Tab Content */}
        {activeTab === "history" && <DistributionHistoryTab shouldFetchData={shouldFetchData} />}
    {activeTab === "payroll" && <PayrollExportTab shouldFetchData={shouldFetchData} />}
    {activeTab === "statements" && <EmployeeStatementsTab shouldFetchData={shouldFetchData} />}
     {activeTab === "analytics" && <DistributionAnalyticsTab shouldFetchData={shouldFetchData} />}
        {activeTab === "compliance" && <HmrcComplianceTab shouldFetchData={shouldFetchData} />}
      </PageLayout>
    </>
  );
};

export default Reports;
